export const COMPANY_SITE = 'https://lodgeofbenevolence5612.co.uk/'
export const COMPANY_SYMBOL_IMG = 'https://idaily-img.s3.eu-west-2.amazonaws.com/m-6u-30-04-25-07-43-43-exam-revision.jpg'
export const COMPANY_NAME_LTD = 'Lodge of Benevolence';
export const COMPANY_ADD_LINE_1 = 'Pudsey Masonic Hall';
export const COMPANY_ADD_LINE_2 = 'Church Lane';
export const COMPANY_ADD_LINE_2a = 'PUDSEY';
export const COMPANY_ADD_LINE_3 = 'LS28 7RF';
export const COMPANY_REGISTRATION_NUMBER = 'Company House Number: 16351318';
export const COMPANY_TITLE = 'Lodge of Benevolence | Masonic Lodge in Pudsey';
export const COMPANY_PHONE = '0113 256 4896';
export const COMPANY_FAX = '0113 256 4896';
export const COMPANY_EMAIL = 'lodgeofbenevolence5612@gmail.com';
export const COMPANY_META_DESCRIPTION =
  'The Lodge of Benevolence No. 5612 in Pudsey unites people from all walks of life through Freemasonry, ' +
  'friendship, integrity, and charitable service to the community.';
export const COMPANY_FACEBOOK_URL = 'https://www.facebook.com/pudseyfreemasons5612/';
export const COMPANY_INSTAGRAM_URL = 'https://www.instagram.com/isg.ltd?igsh=MWFzcXA2MGN6eTQ2eA%3D%3D&utm_source=qr';
export const SECONDARY_COLOR = '#124e8f'
export const THIRD_FONT_COLOR = '#888c92'

